import gql from 'graphql-tag';

export const REPORT_ITEM_FRAGMENT = gql`
  fragment ReportItemFields on BPFReportGroupDealDataViewModel {
    id
    stage
    customer
    location
    closeDate
    department
    grossProfit
    closeStatus
    daysInStage
    probability
    overdueInDays
    invoiceAmount
    weightedAmount
    createdDateTime
    estimatedCloseDate
    dealStatus
  }
`;
